import React from 'react'
import cx from 'classnames'

import ContentLoader from 'react-content-loader'
import { testIdHelper } from 'helpers/formatters'

import colors from '@arrive/style-foundation/variables/colors-js.scss';
import styles from 'components/CPCommittedCapacity/components/MilestonesCell/MilestonesCell.scss'

const { tandem } = colors;
const foregroundColor = '#FAFAFA';

export function MilestonesCell({ title, content, className, testIdString, loading }: { title?: React.ReactNode; content: React.ReactNode; className?: string; testIdString?: string; loading?: boolean; }) {
  if (loading) {
    return <ContentLoader
      key={testIdHelper(testIdString, "loading")}
      interval={0.5}
      speed={1.75}
      gradientRatio={0.5}
      width='100%'
      height='66px'
      backgroundColor={tandem}
      foregroundColor={foregroundColor}
    >
      <rect data-testid={testIdHelper(testIdString, "loading")} x="0" y="0" width="250" height="16"></rect>
      <rect x="0" y="20" width="125" height="20"></rect>
    </ContentLoader>
  }

  return (
    <div className={styles.infoCell} data-testid={testIdHelper(testIdString, 'cell')}>
      {title && <div className={styles.infoTitle}>{title}</div>}
      <div className={cx(styles.infoContent, className)}>{content}</div>
    </div>
  )
}
